import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const OpinionsContainer = styled.section`
	text-align: center;

	${props => props.theme.breakpoints.up('xs')} {
		background-image: linear-gradient(157deg, #000000 8%, #242323 104%);
		padding: 8% 8% 15% 8%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		background-image: linear-gradient(109deg, #000000 18%, #242323 109%);
		padding: 6% 11% 6% 11%;
	}
`;

export const StyledGridContainer = styled(Grid)`
	padding-top: 24px;
`;

export const StyledProgressGrid = styled(Grid)`
	${props => props.theme.breakpoints.up('sm')} {
		padding-right: 5%;
	}
`;

export const StyledDataGrid = styled(Grid)`
	${props => props.theme.breakpoints.up('xs')} {
		padding-top: 12%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		padding-top: 3%;
		padding-left: 5%;
	}
`;
